import React from "react";
import { Marker } from "@react-google-maps/api";
import { compose } from "recompose";
import { connect } from "react-redux";
import { createMapPinIcon } from "./helpers";

function SearchPinManager({ searchPin }) {            
    const icon = createMapPinIcon();
    if (searchPin) {
        return (<Marker icon={icon} position={searchPin} />)
    } else {
        return(<></>)
    }
}

function mapState({ exploreMap }) {
    return {
        searchPin: exploreMap.searchPin
    };
}

function mapDispatch() {
    return { }
};

export default compose(
    connect(mapState, mapDispatch)
)(SearchPinManager);